export function isAuditBrowser() {
  if (typeof navigator === 'undefined') return false;
  return Boolean(navigator.webdriver) || /HeadlessChrome|Lighthouse/i.test(navigator.userAgent || '');
}
